import { memo } from "react";
import type { SvgProps } from "react-native-svg";
import Svg, { Path } from "react-native-svg";

const SvgStarOfLife = (props: SvgProps) => (
  <Svg width={34} height={35} fill="none" {...props}>
    <Path
      stroke="#000154"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.5}
      d="M18.78 1.5a1.78 1.78 0 0 1 1.78 1.778v8.062l6.99-4.03a1.78 1.78 0 0 1 2.432.65l1.78 3.08a1.776 1.776 0 0 1-.652 2.428L24.12 17.5l6.99 4.034a1.78 1.78 0 0 1 .652 2.428l-1.78 3.08a1.78 1.78 0 0 1-2.431.65l-6.991-4.034v8.064a1.777 1.777 0 0 1-1.78 1.778h-3.56a1.78 1.78 0 0 1-1.78-1.778v-8.064L6.45 27.69a1.78 1.78 0 0 1-2.432-.65l-1.78-3.08a1.776 1.776 0 0 1 .652-2.428L9.88 17.5l-6.99-4.032a1.78 1.78 0 0 1-.652-2.428l1.78-3.08a1.78 1.78 0 0 1 2.431-.65l6.991 4.03V3.278A1.777 1.777 0 0 1 15.22 1.5z"
    />
  </Svg>
);
const Memo = memo(SvgStarOfLife);
export default Memo;
